import classNames from 'classnames';

type Props = {
  dataTestId?: string;
  disabled?: boolean;
  id: string;
  maxLength?: number;
  placeholder?: string;
  showErrors?: boolean;
  specialClass?: string;
  type?: string;
  validationErrors?: string[];
  value?: string;
  onBlur?: (e) => void;
  onChange?: (e) => void;
  onKeyPress?: (e) => void;
}
export default function TextInput({
  dataTestId = '',
  disabled = false,
  id,
  maxLength,
  placeholder,
  showErrors = true,
  specialClass,
  type,
  validationErrors = [],
  value,
  onBlur = () => {},
  onChange = () => {},
  onKeyPress = () => {},
}: Props): JSX.Element {

  const className = classNames({
    ['input--text']: true,
    [`input--text__${specialClass}`]: !!specialClass,
    ['has-error']: showErrors && validationErrors.length > 0,
  });

  return (
    <div className="input--text-container">
      <input
        className={className}
        data-test-id={dataTestId}
        disabled={disabled}
        id={id}
        maxLength={maxLength}
        name={id}
        placeholder={placeholder}
        type={type}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        onKeyPress={onKeyPress}
      />
      <ul className="input--text__validation-list">
        {showErrors && validationErrors.map((error) => <li className="input--text__validation-warning" key={error}>{error}</li>)}
      </ul>
    </div>
  );
}
